import { render, staticRenderFns } from "./unKnowTable.vue?vue&type=template&id=2146ed10&scoped=true&"
import script from "./unKnowTable.vue?vue&type=script&lang=js&"
export * from "./unKnowTable.vue?vue&type=script&lang=js&"
import style0 from "./unKnowTable.vue?vue&type=style&index=0&id=2146ed10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146ed10",
  null
  
)

export default component.exports